// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css_AtomicTypes from "bs-css/src/Css_AtomicTypes.bs.js";
import * as CssColorConverter from "css-color-converter";
import * as BsCssJs$PrezzeeRibbon from "../bindings/BsCss/BsCssJs.bs.js";

var black = {
  NAME: "hex",
  VAL: "000000"
};

var white = {
  NAME: "hex",
  VAL: "FFFFFF"
};

var Common_prezzeeRed = {
  NAME: "hex",
  VAL: "F93C28"
};

var Common_darkRed = {
  NAME: "hex",
  VAL: "900C20"
};

var Common_peach = {
  NAME: "hex",
  VAL: "FDF6F3"
};

var Common_tangerine = {
  NAME: "hex",
  VAL: "FF978C"
};

var Common_textSecondary = {
  NAME: "hex",
  VAL: "4B4B4B"
};

var Common_lilac400 = {
  NAME: "hex",
  VAL: "E5E2FB"
};

var Common = {
  black: black,
  white: white,
  inherit_: "currentColor",
  prezzeeRed: Common_prezzeeRed,
  darkRed: Common_darkRed,
  peach: Common_peach,
  tangerine: Common_tangerine,
  textSecondary: Common_textSecondary,
  lilac400: Common_lilac400
};

var Personal_primaryRed = {
  NAME: "hex",
  VAL: "E30B17"
};

var Personal_primaryRedHover = {
  NAME: "hex",
  VAL: "A70A13"
};

var Personal_primaryRedPaleBg = {
  NAME: "hex",
  VAL: "FCE7E8"
};

var Personal_primaryActive = {
  NAME: "hex",
  VAL: "1E2530"
};

var Personal_primaryDisabled = {
  NAME: "hex",
  VAL: "AAB6CA"
};

var Personal_primaryDisabledText = {
  NAME: "hex",
  VAL: "4c5d79"
};

var Personal_whiteHover = {
  NAME: "hex",
  VAL: "E7E7E9"
};

var Personal_darkGrey = {
  NAME: "hex",
  VAL: "444444"
};

var Personal_divider = {
  NAME: "hex",
  VAL: "E9E9E9"
};

var Personal_errorText = {
  NAME: "hex",
  VAL: "87202F"
};

var Personal_activeBlue = {
  NAME: "hex",
  VAL: "3E77B0"
};

var Personal_activeBluePaleBg = {
  NAME: "hex",
  VAL: "ECF1F7"
};

var Personal_charcoal = {
  NAME: "hex",
  VAL: "313E49"
};

var Personal_charcoalHover = {
  NAME: "hex",
  VAL: "20282F"
};

var Personal_darkCharcoal = {
  NAME: "hex",
  VAL: "28323B"
};

var Personal_midGrey = {
  NAME: "hex",
  VAL: "767676"
};

var Personal_lightGrey = {
  NAME: "hex",
  VAL: "A9AAA9"
};

var Personal_lightGreyBackground = {
  NAME: "hex",
  VAL: "ECF2F6"
};

var Personal_paleGrey = {
  NAME: "hex",
  VAL: "F8F8F8"
};

var Personal_paleGreyBackground = {
  NAME: "hex",
  VAL: "E8EEEF"
};

var Personal_lightBlueBackground = {
  NAME: "hex",
  VAL: "F7FBFE"
};

var Personal_paleDivider = {
  NAME: "hex",
  VAL: "EFEFEF"
};

var Personal_green = {
  NAME: "hex",
  VAL: "25AE88"
};

var Personal_orange = {
  NAME: "hex",
  VAL: "DC5800"
};

var Personal_yellow = {
  NAME: "hex",
  VAL: "FAA731"
};

var Personal_yellowPaleBg = {
  NAME: "hex",
  VAL: "FEF7EB"
};

var Personal_orangeBrown = {
  NAME: "hex",
  VAL: "DD5F0A"
};

var Personal_orangeBrownPaleBg = {
  NAME: "hex",
  VAL: "FBEEE6"
};

var Personal_blueIcon = {
  NAME: "hex",
  VAL: "6DB6FF"
};

var Personal_whiteFilledButtonText = {
  NAME: "hex",
  VAL: "33333A"
};

var Personal_darkFieldText = {
  NAME: "hex",
  VAL: "DEDEDE"
};

var Personal_footerDarkBackground = {
  NAME: "hex",
  VAL: "273139"
};

var Personal_mobileHeroBackground = {
  NAME: "hex",
  VAL: "ECF1F6"
};

var Personal_mobilePersonalizeGradient = {
  NAME: "hex",
  VAL: "F6F9FC"
};

var Personal_yetAnotherLightGrey = {
  NAME: "hex",
  VAL: "E7EEF1"
};

var Personal_pureRed = {
  NAME: "hex",
  VAL: "FF0000"
};

var Personal_skyBlue = {
  NAME: "hex",
  VAL: "F6F9FC"
};

var Personal_anchorBlue = {
  NAME: "hex",
  VAL: "2877B5"
};

var Personal = {
  black: black,
  white: white,
  primaryRed: Personal_primaryRed,
  primaryRedHover: Personal_primaryRedHover,
  primaryRedPaleBg: Personal_primaryRedPaleBg,
  primaryActive: Personal_primaryActive,
  primaryDisabled: Personal_primaryDisabled,
  primaryDisabledText: Personal_primaryDisabledText,
  whiteHover: Personal_whiteHover,
  darkGrey: Personal_darkGrey,
  divider: Personal_divider,
  errorText: Personal_errorText,
  activeBlue: Personal_activeBlue,
  activeBluePaleBg: Personal_activeBluePaleBg,
  charcoal: Personal_charcoal,
  charcoalHover: Personal_charcoalHover,
  darkCharcoal: Personal_darkCharcoal,
  midGrey: Personal_midGrey,
  lightGrey: Personal_lightGrey,
  lightGreyBackground: Personal_lightGreyBackground,
  paleGrey: Personal_paleGrey,
  paleGreyBackground: Personal_paleGreyBackground,
  lightBlueBackground: Personal_lightBlueBackground,
  paleDivider: Personal_paleDivider,
  green: Personal_green,
  orange: Personal_orange,
  yellow: Personal_yellow,
  yellowPaleBg: Personal_yellowPaleBg,
  orangeBrown: Personal_orangeBrown,
  orangeBrownPaleBg: Personal_orangeBrownPaleBg,
  blueIcon: Personal_blueIcon,
  whiteFilledButtonText: Personal_whiteFilledButtonText,
  darkFieldText: Personal_darkFieldText,
  footerDarkBackground: Personal_footerDarkBackground,
  mobileHeroBackground: Personal_mobileHeroBackground,
  mobilePersonalizeGradient: Personal_mobilePersonalizeGradient,
  yetAnotherLightGrey: Personal_yetAnotherLightGrey,
  pureRed: Personal_pureRed,
  skyBlue: Personal_skyBlue,
  anchorBlue: Personal_anchorBlue
};

var Business_primary = {
  NAME: "hex",
  VAL: "2D9CDB"
};

var Business_secondary = {
  NAME: "hex",
  VAL: "263557"
};

var Business_primaryBlue = {
  NAME: "hex",
  VAL: "55B6EA"
};

var Business_offWhite = {
  NAME: "hex",
  VAL: "E7EAEE"
};

var Business_cream = {
  NAME: "hex",
  VAL: "FCEFE8"
};

var Business_navy = {
  NAME: "hex",
  VAL: "1D263A"
};

var Business_darkPurple = {
  NAME: "hex",
  VAL: "2B0840"
};

var Business_midPurple = {
  NAME: "hex",
  VAL: "3D085C"
};

var Business_prezzeePurple = {
  NAME: "hex",
  VAL: "48096C"
};

var Business_charcoal = {
  NAME: "hex",
  VAL: "1E1E1E"
};

var Business_stone = {
  NAME: "hex",
  VAL: "F2F1F2"
};

var Business_bodyTextGrey = {
  NAME: "hex",
  VAL: "515151"
};

var Business_spaceGrey = {
  NAME: "hex",
  VAL: "787878"
};

var Business_veryLightGrey = {
  NAME: "hex",
  VAL: "FCFCFD"
};

var Business_shadowGrey = {
  NAME: "hex",
  VAL: "A0A0A0"
};

var Business = {
  black: black,
  white: white,
  primary: Business_primary,
  secondary: Business_secondary,
  primaryBlue: Business_primaryBlue,
  offWhite: Business_offWhite,
  cream: Business_cream,
  navy: Business_navy,
  darkPurple: Business_darkPurple,
  midPurple: Business_midPurple,
  prezzeePurple: Business_prezzeePurple,
  charcoal: Business_charcoal,
  stone: Business_stone,
  bodyTextGrey: Business_bodyTextGrey,
  spaceGrey: Business_spaceGrey,
  veryLightGrey: Business_veryLightGrey,
  shadowGrey: Business_shadowGrey
};

function colourToRgba(c, alpha) {
  var match = CssColorConverter.fromString(Css_AtomicTypes.Color.toString(c)).toRgbaArray();
  return BsCssJs$PrezzeeRibbon.rgba(match[0], match[1], match[2], {
              NAME: "num",
              VAL: alpha
            });
}

var purple700 = {
  NAME: "hex",
  VAL: "2B0840"
};

var purple600 = {
  NAME: "hex",
  VAL: "32064C"
};

var purple500 = {
  NAME: "hex",
  VAL: "410861"
};

var purple400 = {
  NAME: "hex",
  VAL: "48096C"
};

var purple300 = {
  NAME: "hex",
  VAL: "6D3A89"
};

var purple200 = {
  NAME: "hex",
  VAL: "916BA7"
};

var purple100 = {
  NAME: "hex",
  VAL: "DACEE2"
};

var purple50 = {
  NAME: "hex",
  VAL: "EDE6F0"
};

var red700 = {
  NAME: "hex",
  VAL: "480610"
};

var red600 = {
  NAME: "hex",
  VAL: "900C20"
};

var red500 = {
  NAME: "hex",
  VAL: "BE1807"
};

var red400 = {
  NAME: "hex",
  VAL: "ED1E09"
};

var red300 = {
  NAME: "hex",
  VAL: "F1453A"
};

var red200 = {
  NAME: "hex",
  VAL: "F4736B"
};

var red100 = {
  NAME: "hex",
  VAL: "FABCB5"
};

var red50 = {
  NAME: "hex",
  VAL: "FDE9E6"
};

var pink700 = {
  NAME: "hex",
  VAL: "CC7970"
};

var pink600 = {
  NAME: "hex",
  VAL: "FF978C"
};

var pink500 = {
  NAME: "hex",
  VAL: "FFB6AF"
};

var pink400 = {
  NAME: "hex",
  VAL: "FFD2BD"
};

var pink300 = {
  NAME: "hex",
  VAL: "FFE0D1"
};

var pink200 = {
  NAME: "hex",
  VAL: "FFE9DE"
};

var pink100 = {
  NAME: "hex",
  VAL: "FFF6F2"
};

var pink50 = {
  NAME: "hex",
  VAL: "FFFBF8"
};

var lilac700 = {
  NAME: "hex",
  VAL: "A09EB0"
};

var lilac600 = {
  NAME: "hex",
  VAL: "B7B5C9"
};

var lilac500 = {
  NAME: "hex",
  VAL: "CECBE2"
};

var lilac400 = {
  NAME: "hex",
  VAL: "E5E2FB"
};

var lilac300 = {
  NAME: "hex",
  VAL: "EAE8FC"
};

var lilac200 = {
  NAME: "hex",
  VAL: "EDEBFC7"
};

var lilac100 = {
  NAME: "hex",
  VAL: "F7F5FD"
};

var lilac50 = {
  NAME: "hex",
  VAL: "F6F7F9"
};

var blue700 = {
  NAME: "hex",
  VAL: "102C60"
};

var blue600 = {
  NAME: "hex",
  VAL: "174291"
};

var blue500 = {
  NAME: "hex",
  VAL: "1E54B7"
};

var blue400 = {
  NAME: "hex",
  VAL: "276EF1"
};

var blue300 = {
  NAME: "hex",
  VAL: "5B91F5"
};

var blue200 = {
  NAME: "hex",
  VAL: "A0BFF8"
};

var blue100 = {
  NAME: "hex",
  VAL: "D4E2FC"
};

var blue50 = {
  NAME: "hex",
  VAL: "EFF3FE"
};

var green700 = {
  NAME: "hex",
  VAL: "0B3429"
};

var green600 = {
  NAME: "hex",
  VAL: "166852"
};

var green500 = {
  NAME: "hex",
  VAL: "1E8B6D"
};

var green400 = {
  NAME: "hex",
  VAL: "25AE88"
};

var green300 = {
  NAME: "hex",
  VAL: "51BEA0"
};

var green200 = {
  NAME: "hex",
  VAL: "7CCEB8"
};

var green100 = {
  NAME: "hex",
  VAL: "A8DFCF"
};

var green50 = {
  NAME: "hex",
  VAL: "E9F7F3"
};

var yellow700 = {
  NAME: "hex",
  VAL: "806022"
};

var yellow600 = {
  NAME: "hex",
  VAL: "B3862F"
};

var yellow500 = {
  NAME: "hex",
  VAL: "CC9A36"
};

var yellow400 = {
  NAME: "hex",
  VAL: "FFC043"
};

var yellow300 = {
  NAME: "hex",
  VAL: "FFCF70"
};

var yellow200 = {
  NAME: "hex",
  VAL: "FFE3AC"
};

var yellow100 = {
  NAME: "hex",
  VAL: "FFF2D9"
};

var yellow50 = {
  NAME: "hex",
  VAL: "FFFAF0"
};

var orange700 = {
  NAME: "hex",
  VAL: "7D2714"
};

var orange600 = {
  NAME: "hex",
  VAL: "AE371C"
};

var orange500 = {
  NAME: "hex",
  VAL: "CC492C"
};

var orange400 = {
  NAME: "hex",
  VAL: "FF6937"
};

var orange300 = {
  NAME: "hex",
  VAL: "FA9269"
};

var orange200 = {
  NAME: "hex",
  VAL: "FABDA5"
};

var orange100 = {
  NAME: "hex",
  VAL: "FFE1D6"
};

var orange50 = {
  NAME: "hex",
  VAL: "FFF3EF"
};

var black$1 = {
  NAME: "hex",
  VAL: "000000"
};

var gray800 = {
  NAME: "hex",
  VAL: "1E1E1E"
};

var gray700 = {
  NAME: "hex",
  VAL: "302F2F"
};

var gray600 = {
  NAME: "hex",
  VAL: "4B4B4B"
};

var gray500 = {
  NAME: "hex",
  VAL: "787878"
};

var gray400 = {
  NAME: "hex",
  VAL: "A0A0A0"
};

var gray300 = {
  NAME: "hex",
  VAL: "C7C3C3"
};

var gray200 = {
  NAME: "hex",
  VAL: "E0DEDE"
};

var gray100 = {
  NAME: "hex",
  VAL: "F0EDED"
};

var gray50 = {
  NAME: "hex",
  VAL: "F8F8F8"
};

var white$1 = {
  NAME: "hex",
  VAL: "FFFFFF"
};

var accentPink = {
  NAME: "hex",
  VAL: "FFC5EE"
};

var accentYellow = {
  NAME: "hex",
  VAL: "F9FF4E"
};

var accentBlue = {
  NAME: "hex",
  VAL: "88FDFF"
};

export {
  Common ,
  Personal ,
  Business ,
  colourToRgba ,
  purple700 ,
  purple600 ,
  purple500 ,
  purple400 ,
  purple300 ,
  purple200 ,
  purple100 ,
  purple50 ,
  red700 ,
  red600 ,
  red500 ,
  red400 ,
  red300 ,
  red200 ,
  red100 ,
  red50 ,
  pink700 ,
  pink600 ,
  pink500 ,
  pink400 ,
  pink300 ,
  pink200 ,
  pink100 ,
  pink50 ,
  lilac700 ,
  lilac600 ,
  lilac500 ,
  lilac400 ,
  lilac300 ,
  lilac200 ,
  lilac100 ,
  lilac50 ,
  blue700 ,
  blue600 ,
  blue500 ,
  blue400 ,
  blue300 ,
  blue200 ,
  blue100 ,
  blue50 ,
  green700 ,
  green600 ,
  green500 ,
  green400 ,
  green300 ,
  green200 ,
  green100 ,
  green50 ,
  yellow700 ,
  yellow600 ,
  yellow500 ,
  yellow400 ,
  yellow300 ,
  yellow200 ,
  yellow100 ,
  yellow50 ,
  orange700 ,
  orange600 ,
  orange500 ,
  orange400 ,
  orange300 ,
  orange200 ,
  orange100 ,
  orange50 ,
  black$1 as black,
  gray800 ,
  gray700 ,
  gray600 ,
  gray500 ,
  gray400 ,
  gray300 ,
  gray200 ,
  gray100 ,
  gray50 ,
  white$1 as white,
  accentPink ,
  accentYellow ,
  accentBlue ,
}
/* css-color-converter Not a pure module */
